var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"d-flex flex-column align-center justify-center",staticStyle:{"height":"100vh"}},[_c('v-progress-circular',{attrs:{"size":50,"color":"primary","indeterminate":""}}),_c('span',[_vm._v("Loading....")])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }